import React from 'react';
import DocumentsForm from './DocumentsForm';
import { useParams } from 'react-router-dom';

const EditDocumentPage = () => {
     const { id } = useParams();
    return <DocumentsForm formType="edit" currentDocumentId={id} />;
};

export default EditDocumentPage;

